import { Drawer } from 'vaul'

import { getAddInfosByPriceId } from '@/features/user/additional-information/utils'
import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { useSessionContext } from '@/shared/hooks'
import { useBodyScrollLock } from '@/shared/hooks/useBodyScrollLock'
import { useNavigation } from '@/shared/hooks/useNavigation'
import { useUserProgress } from '@/shared/hooks/useUserProgress'
import { useAvatarContext } from '@/shared/ui/Avatar'

import { AppMenuNavSections } from './AppMenuNavSections'
import { AppMenuScrollArea } from './AppMenuScrollArea'
import { useAppMenu } from './AppMenuContext'
import { AppMenuProfileHeader } from './AppMenuProfileHeader'
import { AppMenuQuickActions } from './AppMenuQuickActions'
import { AppMenuRewardsCard } from './AppMenuRewardsCard'

export function AppMenu() {
  const { isOpen, close } = useAppMenu()
  useBodyScrollLock(isOpen)
  const { user } = useSessionContext()
  const {
    digitalProduct,
    lockRules: { startAt: lockStartAt }
  } = useDigitalProductContext()
  const { hasAvatar, avatar } = useAvatarContext()
  const { wallet, title, userProgress } = useUserProgress()
  const { basePathWithId, sidebarNavItems } = useNavigation()

  const ticket = userProgress?.user_tickets?.[0]

  const showAdditionalInfo = ticket
    ? getAddInfosByPriceId({
        digitalProduct: digitalProduct as any,
        priceId: ticket.price_id
      }).length > 0
    : false

  const titleForHeader = title as
    | { name?: string; level?: number }
    | string
    | null

  return (
    <Drawer.Root
      direction="right"
      open={isOpen}
      onOpenChange={open => !open && close()}
    >
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 z-drawer-backdrop bg-black/55" />
        <Drawer.Content className="fixed top-0 right-0 bottom-0 z-drawer flex w-[min(400px,90vw)] max-h-dvh flex-col [--initial-transform:calc(100%+8px)]">
          <div className="flex h-full min-h-0 w-full flex-col overflow-hidden bg-white">
            <div className="shrink-0 bg-white">
              <AppMenuProfileHeader
                user={user}
                hasAvatar={hasAvatar}
                avatar={avatar}
                basePathWithId={basePathWithId}
                title={titleForHeader}
              />

              <AppMenuQuickActions
                basePathWithId={basePathWithId}
                showAdditionalInfo={showAdditionalInfo}
              />
            </div>

            <AppMenuScrollArea>
              <AppMenuNavSections
                items={sidebarNavItems}
                basePathWithId={basePathWithId}
                startAt={lockStartAt}
              />
            </AppMenuScrollArea>

            <AppMenuRewardsCard
              points={Number(wallet.points ?? 0)}
              coins={Number(wallet.coins ?? 0)}
            />
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
